<template>
  <div id="sticky-slot-demo">
    <div class="page-filler d-flex justify-content-center align-items-center mb-4">
      <span>Filler content</span>
    </div>
    <sticky-slot :on-docked="myCallback">
      <div class="d-flex justify-content-center my-3">
        sticky content
      </div>
    </sticky-slot>
  </div>
</template>

<script>
/* eslint-disable no-console */
import StickySlot from 'VueComponents/StickySlot';

export default {
  components: {
    StickySlot,
  },
  methods: {
    // further reading: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#creating_an_intersection_observer
    // custom callback which is invoked when the sticky element comes to rest within its dock position
    myCallback({ elements, event }) {
      // `elements` is an array of elements used by StickySlot:
      console.log(elements);
      // `event` is the IntersectionObserver event which is fired on the same condition:
      console.log(event);

      // the event contains intersection information, particularly useful is 'isIntersecting'

      // this is a good spot to do any styling changes
      // (in fact, you HAVE to do them in script like this, since css has no selector for sticky stuff!)
      if (event.isIntersecting) {
        console.log('intersection complete!');
        elements.container_el.style.fontWeight = 'unset';
      } else {
        console.log('intersection doesn\'t pass threshold');
        elements.container_el.style.fontWeight = 'bold';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-filler {
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: lightblue;
  border: 2px solid black;
}

// just for demonstration
:deep(.sticky-slot-container) {
  border: 1px solid red;
}

:deep(.sticky-slot-dock) {
  border: 1px solid blue;
}

</style>
